import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Paper
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ReusablePDFUploadComponent from "../../components/ReusablePdfComponent";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import ReusableChip from "../../components/reusableComponents/chipSelector";

export default function OfferAgreement() {
  const [selectedFile, setSelectedFile] = useState(null);

  const SectionTitle = ({ children }) => (
    <Typography sx={{ fontWeight: 500, fontSize: 18, color: '#626478', marginBottom: '10px' }}>
      {children}
    </Typography>
  );

  const SubSectionTitle = ({ children }) => (
    <Typography sx={{ fontWeight: 400, fontSize: 14, color: '#A6A6A6', marginBottom: '10px' }}>
      {children}
    </Typography>
  );

  const AgreementTitle = ({ children }) => (
    <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#626478', marginBottom: '10px' }}>
      {children}
    </Typography>
  );

  const handleFileChange = (event) => {
    console.log("PDF selected:", event.target.files[0]);
  };

  const agreementTemplates = [
    { title: "Standard Partnership Agreement" },
    { title: "Product-Based Collaboration" },
    { title: "Content Usage License" },
    { title: "Custom Terms Agreement" }
  ];

  return (
    <Box sx={{ p: 3, bgcolor: "#fafafa" }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Step 4 - Offer Agreement
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box p={2} sx={{ background: "#FFFFFF", borderRadius: 2 }}>
            <SectionTitle>Agreement Templates (Sample Templates)</SectionTitle>
            <SubSectionTitle> Select and upload an agreement document that creators must review before applying. You can download one of the standard templates or upload your own.</SubSectionTitle>
            <Grid container spacing={2}>
              {agreementTemplates.map((template, index) => (
                <Grid item xs={12} sm={6} key={index} alignItems={"stretch"}>
                  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }} >
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
                      <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                        <AgreementTitle>{template.title}</AgreementTitle>
                        <ReusableMuiIcons name="error" sx={{ color: '#626478' }} />
                      </Box>
                      <Button variant="outlined" startIcon={<ReusableMuiIcons name="download" />} sx={{ padding: '5px 50px', borderRadius: 1, border: "1px solid #D6D6D6", color: "#121212", fontSize: '15px', fontWeight: 600, textTransform: 'capitalize', mt: "auto", }}>
                        Download
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box mb={4} p={2} sx={{ background: "#FFFFFF", borderRadius: 2 }}>
            <SectionTitle>Upload Signed Agreement File (PDF)*</SectionTitle>
            <SubSectionTitle> Required: Upload your final agreement document that creators will
              review during application.</SubSectionTitle>
            <ReusablePDFUploadComponent
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
              handleFileChange={handleFileChange}
              error={false}
              errorMsg=""
              helperText=""
            />
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', border: "1px solid #D6D6D6", borderRadius: 2, padding: '12px 20px', gap: 1, mb: 3, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
          <ReusableMuiIcons name="accessTime" sx={{ color: '#FDB428' }} />
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography sx={{ color: '#7A7A7A', fontSize: '14px', fontWeight: 600 }}>Agreement Status</Typography>
            <Typography sx={{ color: '#A6A6A6', fontSize: '14px', fontWeight: 400 }}>The creator has received the agreement and is expected to upload the signed version. You will be notified once it's submitted for your review.</Typography>
          </Box>
        </Box>
        <ReusableChip label="Awaiting Creator" color="#FDB428" bgcolor="#FFF7E9" />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', border: "1px solid #D6D6D6", borderRadius: 2, padding: '12px 20px', gap: 1, mb: 3, }}>
        <Box display="flex" flexDirection="row" gap={1}>
          <ReusableMuiIcons name="draft" sx={{ color: '#7A7A7A' }} />
          <Typography sx={{ color: '#7A7A7A', fontSize: '14px', fontWeight: 600 }}>Original Agreement (Brand Upload)</Typography>
        </Box>
        <Typography sx={{ color: '#A6A6A6', fontSize: '14px', fontWeight: 400 }}>This is the agreement you uploaded during offer creation.</Typography>
        <Box display="flex" flexDirection="row" gap={1} justifyContent={"space-between"} sx={{ borderLeft: "4px solid #D6D6D6", background: "#F9F9F9", padding: '12px 20px', borderRadius: 2 , mt:2}}>
          <Box sx={{display:'flex' , flexDirection:'row' , gap:1}}>
            <ReusableMuiIcons name="draft" sx={{ color: '#7A7A7A' }} />
            <Box display={'flex'} flexDirection={"column"}>
              <Typography sx={{ color: '#7A7A7A', fontSize: '14px', fontWeight: 600 }}>Spotify Premium - 50% Off for Students</Typography>
              <Typography sx={{ color: '#A6A6A6', fontSize: '14px', fontWeight: 400 }}>Uploaded 2024-07-28 • 2.4 MB</Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Button variant="outlined" startIcon={<ReusableMuiIcons name="viewData" />} sx={{borderRadius: 1, border: "1px solid #D6D6D6", color: "#121212", fontSize: '15px', fontWeight: 600, textTransform: 'capitalize', mt: "auto", }}>
              View
            </Button>
            <Button variant="outlined" startIcon={<ReusableMuiIcons name="download" />} sx={{ borderRadius: 1, border: "1px solid #D6D6D6", color: "#121212", fontSize: '15px', fontWeight: 600, textTransform: 'capitalize', mt: "auto", }}>
              Download
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
